import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { FlujoAprobacionPropuestaDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class FlujoAprobacionPropuestaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getFlujoAprobacionPropuestaService(): Observable<BodyListResponse<FlujoAprobacionPropuestaDTO>> {
    return this.http.get<BodyListResponse<FlujoAprobacionPropuestaDTO>>(API_URL + '/api/v1/flujoAprobacionPropuesta/todos');
  }

  guardarFlujoAprobacionPropuestaService(flujoAprobacionPropuestaDTO: FlujoAprobacionPropuestaDTO): Observable<BodyResponse<FlujoAprobacionPropuestaDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/flujoAprobacionPropuesta', flujoAprobacionPropuestaDTO);
  }

  getFlujoAprobacionPropuestaPorCodigoService(codigo: string): Observable<BodyResponse<FlujoAprobacionPropuestaDTO>> {
    return this.http.get<BodyResponse<FlujoAprobacionPropuestaDTO>>(API_URL + '/api/v1/flujoAprobacionPropuesta/' + codigo);
  }
}
